<template>
  <div :style="{'display':(hidden ? 'none' : 'block')}">
    <div class="dropzone" ref="dz">
      <div id="dropzone-message" style="display: none;">
        <span class="dropzone-title">Drop files here or click to select</span>
        <span class="dropzone-info">You can upload multiple files at once</span>
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from 'dropzone'
import '../../node_modules/dropzone/dist/dropzone.css'
Dropzone.autoDiscover = false;

export default {
  name: 'Dropzone',
  props: {
    disabled: Boolean,
    limit: {
      type: [Number, String],
      default: 0
    },
    preload: {
      type: Array,
      default: function() { return []; }
    },
    hidden: Boolean
  },
  data: () => ({
    dropzone: null,
    queuedFiles: [],

    supressEmits: false
  }),
  mounted: function() {
    let _this = this;
    let dropzoneOptions = {
      url:                    process.env.VUE_APP_API_URL + 'media/upload?expand=user',
      headers:                { "Authorization": "Bearer " + this.$store.state.access_token },
      maxFilesize:            100,
      method:                 'post',
      maxFiles:               (parseInt(this.limit) != 0 ? parseInt(this.limit) : null),
      timeout:                null,
      parallelUploads:        3,
      maxThumbnailFilesize:   8,
      thumbnailWidth:         150,
      thumbnailHeight:        150,
      addRemoveLinks:         false,
      init: function() {
        /*this.on("sending", function(file,xhr,formData) {

        });*/

        this.on("maxfilesexceeded", function(file) {
          if(!_this.supressEmits) _this.$emit('on-max-exceeded', file);
          this.removeFile(file);
        });

        this.on("addedfile", function(file) {
          file.identifier = _this.getNewIdentifier();
          if(!_this.supressEmits) _this.$emit('on-add', file);
        });

        this.on("removedfile", function(file) {
          if(!_this.supressEmits) _this.$emit('on-remove', file);
        });

        

        this.on("processing", function(file) {
          if(!_this.supressEmits) _this.$emit('on-processing', file);
        });

        this.on("queuecomplete", function() {
          if(!_this.supressEmits) _this.$emit('on-queue-complete', this.getAcceptedFiles());
        });

        this.on("uploadprogress", function(file, progress) {
          if(!_this.supressEmits) _this.$emit('on-upload-progress', {file: file, progress: progress});
        });

        this.on("success", function(file, response) {
          if(!_this.supressEmits) _this.$emit('on-success', {file: file, response: response});
        });
        this.on("error", function(file, response) {
          let message = '';
          if(typeof response !== 'object') {
            message = response;
          } else {
            if(typeof response.message === 'object') {
              for(let i = 0; i < response.message.length; i++) {
                message += response.message[i].message + '<br>';
              }
            } else {
              message = response.message;
            }
          }
          if(!_this.supressEmits) _this.$emit('on-error', {file:file, response: response, message: message});
        });

        this.on("complete", function(file) {
          if(!_this.supressEmits) _this.$emit('on-complete', file);
        });

        for(let i = 0; i < _this.preload.length; i++) {
          if(!_this.supressEmits) this.emit('addedfile', _this.preload[i]);
          this.files.push(_this.preload[i]);
        }
      }
    }

    this.dropzone = new Dropzone(this.$refs.dz, dropzoneOptions);
  },
  watch: {
    disabled: function(newVal) {
      if(newVal) {
        this.dropzone.disable();
      } else {
        this.dropzone.enable();
      }
    }
  },
  beforeDestroy: function() {
    this.supressEmits = true;
    this.dropzone.destroy();
  },
  methods: {
    getNewIdentifier: function() {
      return Date.now() + '-' + Math.random().toString(36).substring(2, 15);
    },
    addFile: function(file) {
      this.dropzone.addFile(file);
    },
    reset: function() {
      if(this.dropzone) this.dropzone.removeAllFiles();
    }
  }
}

</script>

<style lang="scss" >
  .dropzone {
    max-width: 600px;
    margin: 0 auto;
    background-color: #F0F0F0;
    .dz-message{
      .dz-button {
        font-size: 20px;
        margin-top: 10px;
      }
    }

    .dz-image {
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .dz-preview.dz-image-preview {
      background: transparent;
    }
  }
</style>